import { useRef } from 'react'
import classNames from 'classnames'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { GretaAIChatAskElsewhere } from '../GretaAIChatAskElsewhere'
import { GretaAIChatMarkdown } from '../GretaAIChatMarkdown'
import {
  GretaAIChatAssistantActions,
  GretaAIChatUserActions,
} from '../GretaAIChatMessageActions'

import { QA_NAME_GRETA_AI_CHAT_MESSAGE } from './GretaAIChatMessage.constants'
import { getIsGretaAIChatUserRole } from './GretaAIChatMessage.utils'

import * as styles from './GretaAIChatMessage.module.css'

function GretaAIChatMessage({
  askElsewhereTarget = null,
  canRetry,
  className = styles.message,
  createdAt,
  feedback,
  id,
  isLatestAssistant,
  isLimitReached = false,
  isPendingId,
  now,
  ref,
  role,
  spacingClassName,
  text,
  onAskElsewhere = EMPTY_FUNCTION,
  onRetry,
  onSubmitFeedback = EMPTY_FUNCTION,
}) {
  const isUser = getIsGretaAIChatUserRole(role)

  const contentRef = useRef(null)

  const messageClassName = classNames(
    className,
    styles[role],
    spacingClassName,
    {
      [styles.toolbarPinned]: isLatestAssistant || canRetry,
    }
  )

  const qaProps = getQaSelector({
    context: role,
    value: QA_NAME_GRETA_AI_CHAT_MESSAGE,
  })

  function handleSubmitFeedback(details) {
    onSubmitFeedback(id, details)
  }

  return (
    <div {...qaProps} className={messageClassName} ref={ref}>
      <div className={styles.content} ref={contentRef}>
        {isUser ? (
          <div className={styles.bubble}>{text}</div>
        ) : (
          <GretaAIChatMarkdown text={text} />
        )}
      </div>

      {askElsewhereTarget ? (
        <GretaAIChatAskElsewhere
          target={askElsewhereTarget}
          onAsk={onAskElsewhere}
        />
      ) : null}

      {isUser ? (
        <GretaAIChatUserActions
          canRetry={canRetry}
          contentRef={contentRef}
          createdAt={createdAt}
          isLimitReached={isLimitReached}
          now={now}
          text={text}
          onRetry={onRetry}
        />
      ) : (
        <GretaAIChatAssistantActions
          contentRef={contentRef}
          createdAt={createdAt}
          feedback={feedback}
          isPendingId={isPendingId}
          now={now}
          text={text}
          onSubmitFeedback={handleSubmitFeedback}
        />
      )}
    </div>
  )
}

export default GretaAIChatMessage
